import { createStore } from 'vuex';
import auth from './modules/auth';
import user from './modules/user';
import coffee_break from './modules/break';
import room from './modules/room';
import course from './modules/course';
import booking from './modules/booking';
import courseReservation from './modules/courseReservation';
import courseSchedule from './modules/courseSchedule';
import roomService from '../services/roomService';
import space from './modules/space';
import spaceBooking from './modules/spaceBooking';

const store = createStore({
  state: {
    loading: false,
    alert: {
      show: false,
      message: '',
      type: 'info'
    },
    rooms: [],
    disabledDates: [],
  },
  mutations: {
    setAlert(state, { show, message, type }) {
      state.alert.show = show;
      state.alert.message = message;
      state.alert.type = type;
    },
    SET_ROOMS(state, rooms) {
      state.rooms = rooms;
    },
    SET_DISABLED_DATES(state, dates) {
      state.disabledDates = dates;
    },
  },
  actions: {
    showAlert({ commit }, { message, type }) {
      commit('setAlert', { show: true, message, type });
      setTimeout(() => {
        commit('setAlert', { show: false, message: '', type: 'success' });
      }, type === 'success' ? 3000 : 5000);
    },
    async fetchRooms({ commit }) {
      try {
        const response = await roomService.getRooms();
        if (response.success) {
          commit('SET_ROOMS', response.data);
        }
        return response;
      } catch (error) {
        console.error('Error fetching rooms:', error);
        throw error;
      }
    },
    async fetchAvailableDates({ commit }, { roomId, bookingType }) {
      try {
        const response = await roomService.getAvailableDates(roomId, bookingType);
        if (response.success) {
          commit('SET_DISABLED_DATES', response.data);
        }
        return response;
      } catch (error) {
        console.error('Error fetching available dates:', error);
        throw error;
      }
    },
  },
  getters: {
  },
  modules: {
    auth,
    user,
    coffee_break,
    room,
    course,
    booking,
    courseReservation,
    courseSchedule,
    space: {
      namespaced: true,
      ...space
    },
    spaceBooking
  }
});

export default store;
